export const Routing = {
    /* Designer Pages */
    DesignerLanding: '/designer/home',
    /* Developer Pages */
    Landing: '/',
    Clinicians: '/clinicians',
};
